import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Empty, Modal, Tooltip, Spin } from 'antd';
import Icofont from 'react-icofont';

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

import {
    LoadingOutlined,
    MoreOutlined
} from '@ant-design/icons';

import { Action, GET, GETWITH, Model, QueryDetail, QueryOrder, deleteInArray, updateInArray } from 'fennec-ui'
import { DropdownAction } from 'fennec-ui'
// import KategoriiUchastnikovNaMeropriyatiyakh from '../KategoriiUchastnikovNaMeropriyatiyakh'
import { errorCatch, POST } from 'fennec-ui'

import "./index.css"

const DragHandle = sortableHandle(() => <Icofont icon="expand-alt" style={{ cursor: 'grabbing', color: '#999' }} />);
const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);


export default function VkGruppiVMastereList(props) {
    const [loading, setLoading] = useState(false);
    const { auth, master, updateVkGruppi } = props;

    const [_vkgruppi, setVkGruppi] = useState([])
    useEffect(() => {
        setLoading(true)
        GETWITH(auth, `/api/vkgruppivmastere/list/${master.ID}`,
            [
                QueryOrder("prioritet","DESC")
            ],
            ({ data }) => {
                setVkGruppi(data)
                updateVkGruppi(data)
                setLoading(false)
            },
            (err) => errorCatch(err, () => setLoading(false))
        )
    }, [master])

    const vkgruppi = _vkgruppi.sort((a, b) => {
        return a.sort - b.sort;
    }).map((item, index) => {
        return { ...item, sort: index };
    });

    const group_delete = React.useCallback((group) => {
        // /api/vkgruppivmastere/delete
        setLoading(true)
        GET(auth, `/api/vkgruppivmastere/delete/${group?.ID}`,
            () => {
                setVkGruppi(o => deleteInArray(o, group))
                updateVkGruppi(o => deleteInArray(o, group))
                setLoading(false)
            },
            (err) => errorCatch(err, () => setLoading(false)));
    }, [master]);
    const postSetOrder = (groups) => {
        setLoading(true);
        POST(auth, "/api/vkgruppivmastere/prioritet", groups,
            ({ data }) => {
                setVkGruppi(data)
                updateVkGruppi(data)
                setLoading(false);
            },
            (err) => errorCatch(err, setLoading(false)));
    };
    const columns = () => {
        var c = [];

        c.push({
            width: 30,
            className: 'drag-visible',
            render: () => <DragHandle />,
        });

        c.push({
            title: 'Группа в VK',
            render: (text, record) => {
                return (
                    <div>
                        {record?.gruppa?.nazvanie}
                    </div>
                );
            },
            key: 'nazvanie',
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                return (
                    <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                        // {
                        //     ...props,
                        //     readonly: false,
                        //     mode: "MenuItem",
                        //     auth: auth,
                        //     context: object,
                        //     object: record,
                        //     action: (values, unlock, close) => updateAction(record, values, unlock, close),
                        //     form: KategoriiUchastnikovNaMeropriyatiyakhUpdate,
                        //     title: "Изменить",
                        //     modal: {
                        //         title: "Изменить",
                        //         minWidth: "600px",
                        //     }
                        // },
                        {
                            title: "Удалить",
                            mode: "MenuItem",
                            action: () => group_delete(record)
                        }
                    ]} />);
            },
        });


        return c;
    };
    // const updateAction = (record, values, unlock, close) => {
    //     setLoading(true)
    //     POST(auth, "/api/vkgruppivmastere/update", {
    //         ...record,
    //         ...values,
    //     },
    //         ({ data }) => {
    //             if (data) {
    //                 setVkGruppi(updateInArray(_vkgruppi, data))
    //                 updateVkGruppi(updateInArray(_vkgruppi, data))
    //             }
    //             setLoading(false)
    //             close();
    //         },
    //         (err) => errorCatch(err, () => { setLoading(false); unlock(); }));
    // };
    const createAction = (values, unlock, close) => {
        setLoading(true)
        POST(auth, "/api/vkgruppivmastere/create", {
            ...values,
            masterPostovID: master.ID
        },
            ({ data }) => {
                if (data) {
                    setVkGruppi(updateInArray(_vkgruppi, data))
                    updateVkGruppi(updateInArray(_vkgruppi, data))
                }
                setLoading(false)
                close();
            },
            (err) => errorCatch(err, () => { setLoading(false); unlock(); }));
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const dataSource = vkgruppi;
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
            postSetOrder(newData);
        }
    };

    const DraggableContainer = props => (
        <SortableContainer
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const dataSource = vkgruppi;
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex(x => x.sort === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    return (
        <>
            <Action
                key="vkgruppa"
                // {...props}
                // readonly={false}
                // triggerStyle={{ marginBottom: "5px" }}
                // triggerOptions={{
                //     type: "primary",
                //     style: { paddingBottom: "50px" }
                // }}
                auth={auth}
                action={createAction}
                form={Model}
                meta={[
                    {
                        label: "Группа",
                        name: "gruppa",
                        type: "object",
                        relation: {
                            display: (item) => {
                                return item.nazvanie
                            },
                            reference: { object: "VkGroups", property: "ID", source: "/api/vkgroups/list" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryOrder("ID", "ASC")
                        ]
                    },
                    // {
                    //     label: "Приоритет",
                    //     name: "prioritet",
                    //     type: "int",
                    // },
                ]}
                title={"Добавить группу"}
                mode={"func"}
                trigger={(click) => (
                    <Tooltip title="Добавить группу">
                        <div className={`bg bg-grey pointer`} onClick={click} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center", marginBottom: "10px" }}>
                            {!loading && <i className="fa fa-plus" style={{ fontSize: "12px" }}></i>}
                            {loading && <Spin
                                indicator={
                                    <LoadingOutlined
                                        style={{
                                            color: "grey",
                                            fontSize: 12,
                                        }}
                                        spin
                                    />
                                }
                            />}
                        </div>
                    </Tooltip>
                )}
            // modal={{
            //     minWidth: "400px",
            // }}
            // mode={"button"}
            />
            <Table
                loading={loading}
                columns={columns()}
                pagination={false}
                dataSource={vkgruppi}
                locale={{ emptyText: <Empty description={"Нет категорий участников"}></Empty> }}
                size="small"
                rowKey={r => r.sort}
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                    },
                }}
            />
        </>
    );
}
